import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {Home} from 'features/Home';
import {NotFound} from 'components/NotFound';
import {withContext} from 'utilities/loaders/utilities';
import {getSerialized} from 'utilities/server-data';
import {setLoaderContext} from 'utilities/loaders/context';
import {client as apolloClient} from 'foundation/GraphQL/apollo-client';
import {ErrorFallback} from 'components/ErrorFallback/ErrorFallback';

import {loader as rootLoader} from './loader';
import {RootProviders} from './RootProviders';

const {locale, shop} = getSerialized();

setLoaderContext('app', {
  graphQL: apolloClient,
  locale,
  shop,
});

const router = createBrowserRouter([
  {
    element: <RootProviders />,
    loader: withContext(rootLoader),
    id: 'app',
    errorElement: <ErrorFallback />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      // Other services (ex. Search & Discovery app) have hardcoded urls to resource translation pages
      // If making a route change, make sure to check for hardcoded urls across Shopify and update them
      {
        path: '/localize/:resourceType',
        async lazy() {
          const {lazyComponent} = await import('features/Translations/route');
          const result = await lazyComponent();
          return {Component: result.default};
        },
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

function Routes() {
  return <RouterProvider router={router} />;
}

export default Routes;
